import React from 'react';
import { GetPageComponentViewModel } from '@/types/cml-api';
import { ExperimentWrapper } from '@/features/experiments/experiment-wrapper';
import PersonalizedProductList from './personalized-product-list';
import { LocationType } from '../type';
interface Props {
  data: GetPageComponentViewModel;
  isLazy: boolean;
  locationType: LocationType;
}
const PersonalizedProductListExperiment = ({
  data,
  isLazy,
  locationType
}: Props) => {
  return <ExperimentWrapper experimentTitle='homepage_personalized_product_carousel' fallback={null} versions={{
    with_carousel: () => <PersonalizedProductList data={data} isLazy={isLazy} locationType={locationType} />,
    without_carousel: null
  }} data-sentry-element="ExperimentWrapper" data-sentry-component="PersonalizedProductListExperiment" data-sentry-source-file="personalized-product-list-experiment.tsx" />;
};
export default PersonalizedProductListExperiment;